<template>
  <vue-scroll>
    <el-row type="flex" justify="end">
      <el-col :span="6">
        <label for="sele" class="label">Seleccionar App: </label>
        <el-select
          id="sele"
          v-model="App"
          @change="AppFilter"
          :clearable="true"
          placeholder="App"
        >
          <el-option
            v-for="item in optionsApp"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-container v-if="App === 'ClientService'">
      <el-header>
        <el-alert
          title="Reporte de clientes con o sin la app de Servicio al Cliente"
          type="info"
          show-icon
          effect="dark"
        >
        </el-alert>
      </el-header>

      <ReportAppCustomerService />
    </el-container>

    <el-container v-if="App === 'CHorse'">
      <el-header>
        <el-alert
          title="Reporte de clientes con o sin la app de C Horse"
          type="warning"
          show-icon
          effect="dark"
        >
        </el-alert>
      </el-header>
      <el-main> </el-main>
    </el-container>

    <el-container v-if="App === 'TennosBalance'">
      <el-header>
        <el-alert
          title="Reporte de clientes con o sin la app de Tennos Balance"
          type="error"
          show-icon
          effect="dark"
        >
        </el-alert>
      </el-header>
      <el-main> </el-main>
    </el-container>
  </vue-scroll>
</template>

<script>
import ReportAppCustomerService from "@/components/customer_service/reports/ReportAppCustomerService.vue";

export default {
  name: "RportClientsWithOrWithoutApp",

  data() {
    return {
      App: "ClientService",

      optionsApp: [
        {
          value: "ClientService",
          label: "Servicio al Cliente"
        },
        {
          value: "CHorse",
          label: "C Horse"
        },
        {
          value: "TennosBalance",
          label: "Tennos Balance"
        }
      ]
    };
  },
  components: {
    ReportAppCustomerService
  },
  methods: {
    AppFilter() {}
  }
};
</script>

<style scoped>
.label {
  margin-right: 7px;
  margin-top: 5px;
}
</style>
